module.exports = __webpack_public_path__ + "static/media/play2.f7e144b8.svg";